"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_js_1 = require("@tangibleplay/http-js");
var urls_1 = require("../../config/urls");
var websites_1 = require("../../../config/websites");
var normalizer_1 = __importDefault(require("./normalizer"));
var endpoint = '/api/v3/orders/purchase';
var purchase = function (_a) {
    var raw = _a.raw, environment = _a.environment, _b = _a.website, website = _b === void 0 ? websites_1.WebsiteValues.playosmo : _b, payloadData = _a.data;
    return __awaiter(void 0, void 0, void 0, function () {
        var request, response, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    request = {
                        website: website,
                        card_id: payloadData.cardId,
                        billing_zip: payloadData.billingZip,
                        stripe_token: payloadData.stripeToken,
                        stripe_token_created: payloadData.stripeTokenCreated,
                        card_label: payloadData.cardLabel,
                        card_type: payloadData.cardType,
                        save_card: payloadData.saveCard,
                        affirm_token: payloadData.affirmToken,
                        paypal_order_id: payloadData.paypalOrderId,
                        created_on: payloadData.createdOn,
                        misc_data: payloadData.miscData,
                        shipping_address_id: payloadData.shippingAddressId,
                        shipping_first_name: payloadData.shippingFirstName,
                        shipping_last_name: payloadData.shippingLastName,
                        shipping_address_1: payloadData.shippingAddress1,
                        shipping_address_2: payloadData.shippingAddress2,
                        shipping_address_3: payloadData.shippingAddress3,
                        shipping_city: payloadData.shippingCity,
                        shipping_state: payloadData.shippingState,
                        shipping_zip: payloadData.shippingZip,
                        shipping_country: payloadData.shippingCountry,
                        shipping_method: payloadData.shippingMethod,
                        email: payloadData.email,
                        shipping_phone: payloadData.shippingPhone,
                        coupon_code: payloadData.couponCode,
                        referral: payloadData.referral,
                        unique: payloadData.unique,
                        currency: payloadData.currency,
                        displayed_shipping: typeof payloadData.displayedShipping === 'string'
                            ? parseInt(payloadData.displayedShipping)
                            : payloadData.displayedShipping,
                        displayed_tax: typeof payloadData.displayedTax === 'string'
                            ? parseInt(payloadData.displayedTax)
                            : payloadData.displayedTax,
                        displayed_total: typeof payloadData.displayedTotal === 'string'
                            ? parseInt(payloadData.displayedTotal)
                            : payloadData.displayedTotal,
                        source: payloadData.source,
                        source_host: payloadData.sourceHost,
                        cart_id: payloadData.cartId,
                        cart: payloadData.cart,
                        referral_discount: payloadData.referralDiscount,
                        website_language: payloadData.websiteLanguage,
                        consent_given: payloadData.consentGiven,
                        promo_code: payloadData.promoCode,
                        gift_email: {
                            email: payloadData.giftEmail.email,
                            child_name: payloadData.giftEmail.childName,
                            message: payloadData.giftEmail.message,
                        },
                        checkout: payloadData.cartType,
                        order_extra_data: payloadData.orderExtraData,
                        displayed_credits_used: payloadData.displayedCreditsUsed,
                        additional_discount: typeof payloadData.additionalDiscount === 'string'
                            ? parseInt(payloadData.additionalDiscount)
                            : payloadData.additionalDiscount,
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, (0, http_js_1.fetch)({
                            apiUrl: (0, urls_1.getPlayOsmoAPIUrl)(environment),
                            endpoint: endpoint,
                            body: request,
                            method: 'POST',
                            credentials: 'include',
                        }, true)];
                case 2:
                    response = _c.sent();
                    return [3, 4];
                case 3:
                    error_1 = _c.sent();
                    throw error_1;
                case 4: return [2, raw ? response : (0, normalizer_1.default)(response)];
            }
        });
    });
};
exports.default = purchase;
